import { render, staticRenderFns } from "./edit-us.vue?vue&type=template&id=f467f832"
import script from "./edit-us.vue?vue&type=script&lang=js"
export * from "./edit-us.vue?vue&type=script&lang=js"
import style0 from "./edit-us.vue?vue&type=style&index=0&id=f467f832&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports